import { bootstrapApplication } from '@angular/platform-browser';
import { publicAppConfig } from './app.config';
import { PublicApp } from './app';

bootstrapApplication(PublicApp, publicAppConfig)
  .catch((err) => console.error(err));
